var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnDashboardAp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_974_10220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1667 9H21.8333C14.7457 9 9 14.7457 9 21.8333V38.1667C9 45.2543 14.7457 51 21.8333 51H38.1667C45.2543 51 51 45.2543 51 38.1667V21.8333C51 14.7457 45.2543 9 38.1667 9Z",
    fill: "#F7F7F7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_974_10220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.3656 27.6782C40.6998 28.3486 40.0236 29.0155 39.3371 29.6998C36.8048 27.2057 33.7448 25.9031 30.1845 25.9031C26.6311 25.9031 23.5676 27.1814 20.9906 29.7346C20.3248 29.0502 19.6658 28.3729 19 27.6955C25.0718 21.4013 35.3283 21.4742 41.3656 27.6782Z",
    fill: "#B4E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9843 31.7737C27.0512 27.6506 33.612 27.8859 37.351 31.7701C37.3162 31.8053 37.2918 31.8509 37.2534 31.8896C36.643 32.5041 36.0326 33.1187 35.4362 33.7404C35.3455 33.8317 35.2932 33.8211 35.2129 33.7404C34.2189 32.7394 33.0225 32.1108 31.6483 31.8439C30.7414 31.6683 29.8311 31.6578 28.9207 31.8088C27.6337 32.023 26.4966 32.5568 25.5025 33.3962C25.3386 33.5332 25.1886 33.6912 25.0596 33.8071C24.362 33.1187 23.6784 32.4515 22.9912 31.7737H22.9843Z",
    fill: "#B4E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1355 39.0002C29.6447 38.506 29.1644 38.0082 28.6805 37.514C28.1792 37.0092 27.6848 36.5044 27.18 36.0031C27.0783 35.9007 27.0643 35.8372 27.18 35.7348C28.8453 34.1992 31.4362 34.1957 33.0945 35.7172C33.2172 35.8266 33.2313 35.8831 33.1015 36.0137C32.1339 36.988 31.1768 37.9658 30.2126 38.9437C30.2021 38.9543 30.1846 38.9649 30.139 38.9966L30.1355 39.0002Z",
    fill: "#B4E2FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_974_10220",
    x: 8.5,
    y: 8,
    width: 42.5,
    height: 43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.5,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_974_10220"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_974_10220",
    x: 19,
    y: 23,
    width: 22.3656,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.519142 0 0 0 0 0.889958 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_974_10220"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDashboardAp);
export default __webpack_public_path__ + "static/media/icn_dashboard_ap.5cfaa7ae76acc661eeed4bf7aedb52e0.svg";
export { ForwardRef as ReactComponent };